import { render } from "./AuteurList.vue?vue&type=template&id=1fdacd00&scoped=true"
import script from "./AuteurList.vue?vue&type=script&lang=js"
export * from "./AuteurList.vue?vue&type=script&lang=js"

import "./AuteurList.vue?vue&type=style&index=0&id=1fdacd00&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fdacd00"]])

export default __exports__